import React from 'react'

import { ReversedGradientBorder } from '../commons'
import * as styles from './index.module.css'

const LidarAccessories = ({ title, subtitle, components }) => {
  return (
    <div className={styles.container}>
      <ReversedGradientBorder
        className={styles.gradBorder}
        height="1px"
      ></ReversedGradientBorder>
      <div className={styles.titleContainer}>
        <h2 className={styles.title}>{title}</h2>
      </div>
      <div className={styles.comparisonContainer}>
        {components.map((comp, idx) => (
          <div className={styles.row} key={idx}>
            <div className={`${styles.category} `}>
              {comp.subtitle.subtitle.split('\n')[0]}
            </div>
            {comp.subtitle.subtitle
              .split('\n')
              .slice(1)
              .map((val, idx) => (
                <div key={idx} className={styles.value}>
                  {val}
                </div>
              ))}
          </div>
        ))}
      </div>
    </div>
  )
}

export default LidarAccessories
